module.exports = __webpack_public_path__ + "img/promotion1_in_mid.3e1ffe1b.png";